export enum CLOSE_BTN_CATEGORY {
  DEFAULT,
  PROMOTIONAL_POPUP,
  /** Atlas Figma 2827:14608 — vuesax/bold/close-circle; OpenLeadDrop popups only. */
  LEADDROP_WITH_LEAD_TITLE,
  /**
   * The dialog draws NO close button, because its content draws its own.
   *
   * Every other member picks WHICH × to draw, so there was previously no way to say "none"
   * — a caller whose content already had a close affordance had to pick one of these and
   * got two stacked in the same corner. That is exactly what happened to the config-driven
   * lead form popup, whose skin owns its own ×.
   *
   * Appended rather than inserted: this is a numeric enum, so adding a member anywhere but
   * the end renumbers the existing ones.
   */
  NONE,
}
